import { Column, TABLE_ACTION, defaultColDef, defaultColActionDef } from '@qrios/frontend-library';

import locales from '../../../../../../constants/commonLocales';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';
import { queryTypesFormatter } from '../../../../../common/table/utils/queryTypesFormatter';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: locales.table.column.operationId,
    flex: 2,
    minWidth: 150
  },
  predefinedColumns.date({}),
  {
    ...defaultColDef,
    flex: 3,
    field: 'queryType',
    headerName: locales.table.column.query_type,
    valueFormatter: queryTypesFormatter,
    sortable: true
  },
  predefinedColumns.status({}),
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
